export const SOL_CONST=[
    { label:'Angular',color:'red'},
    { label:'ReactJS',color:'green'},
    { label:'Java EE',color:'blue'},
    { label:'Javascript',color:'purple'},
    { label:'Spring boot',color:'yellow'},
    { label:'Salesforce',color:'grey'},
    { label:'Node JS',color:'pink'},

]